<template>
    <div class="full-width add-on-block-outer" :class="{ 'alternative': (current.price ? current.price : current.full_package_price) > package.price, 'full-experience': (current.price ? current.price : current.full_package_price) < package.price}">
        <div class="fields selection add-on-block" v-bind:class="{ checked: checkedC}">
            <input type="radio" v-model="selection.packages[0]" name="packageSelection" :id="package.id" :value="package.id" :checked="checkedC">
            <label :for="package.id">
                <div class="full-width-field-block">

                    <div class="add-on-checkbox-container">
                        <div class="checkbox">
                        </div>

                        <div class="title">
                            <span v-if="selection.hasOwnProperty('toSwapPackage') && selection.toSwapPackage == package.id"><b>{{ locale.text_current_selection }}:</b> {{ package.name }}</span>
                            <span v-else-if="(current.price ? current.price : current.full_package_price) == package.price">{{ package.name }}</span>
                            <span v-else-if="(current.price ? current.price : current.full_package_price) < package.price"> {{ package.name }}</span>
                            <span v-else><b>{{ locale.text_alternative_option }}:</b> {{ package.name }}</span>
                        </div>
                    </div>
                    <div class="block-content">
                        <div class="content-block" v-html="package.full_description"></div>
                    </div>

                    <div class="block-image" v-bind:style="{ background: 'url('+package.image_url+') center center / contain no-repeat' }"></div>
                </div>

                <div class="add-on-checkbox-container-warning" v-if="checked && programme && (current.package_id !== selection.toSwapPackage)">
                    <i class="fa fa-warning"></i>
                    <div class="warning">
                        {{ locale.text_automatic_selection_warning.replace(':package', baseProgramme) }}
                    </div>
                </div>

            </label>
        </div>
    </div>
</template>

<script>
    Array.prototype.diff = function(a) {
        return this.filter(function(i) {return a.indexOf(i) < 0;});
    };
    export default {
        props: ['base', 'current', 'package', 'selection', 'checked', 'baseProgramme', 'locale'],
        methods: {
            update: function () {

                //Getting the programme id by getting the difference between the base programmes and this package ids.
                var programmes = this.package.programme_ids.diff(this.base.programme_ids);

                //Getting the addon name + icon_url
                if(programmes.length > 0)
                    this.programme = true;
                else
                    this.programme = false;

                if(this.checked) {
                    this.selection.packages[0] = this.package.id;
                    return false;
                }
            }
        },
        data() {
            return {
                programme: false
            }
        },
        created() {
            this.update();
        },
        watch: {
            "current.id": function (oldVal, newVal) {
                this.$forceUpdate();
                this.update();
            },
        },
        computed: {
            priceChange: function() {
                var diff = this.package.price - this.current.price;
                return (diff >= 0 ? (diff == 0 ? false :'+ £'+Math.abs(diff)) : '- £'+Math.abs(diff));
            },
            checkedC: function() {
                return this.checked == true || this.selection.packages[0] == this.package.id;
            },
            isQuickAdd: function () {
                return this.quick != undefined && this.quick == true;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// AddonSelection.vue?6ff088d0